import { render, staticRenderFns } from "./NickName.vue?vue&type=template&id=058ee7ef&scoped=true"
import script from "./NickName.vue?vue&type=script&lang=js"
export * from "./NickName.vue?vue&type=script&lang=js"
import style0 from "./NickName.vue?vue&type=style&index=0&id=058ee7ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058ee7ef",
  null
  
)

export default component.exports